<template>
  <div>

      <div class="filter search_only">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
      </div>

    <form>
      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="recipient-list">
          <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"/>
              <sorting-table-title
                  v-for="title in sortingTableTitles"
                  :key="title.key"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>
            <recipient-row v-for="entity in entities"
                           :entity="entity"
                           :key="entity.id"
                           @input="select"
                           :selectedEntities="selectedEntities"
                           @updateTemplate="updateEntity"
                           @deleteTemplate="deleteEntity"
            ></recipient-row>
            <tr v-if="entities.length === 0">
                 <td colspan="8">{{ $gettext('Nebyly nalezeni žádní příjemci.') }}</td>
            </tr>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          @limit="setLimit"
          @offset="setOffset"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          table-id="recipient-list"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          ref="action_line"
      ></list-action-line>
    </form>
  </div>

</template>

<script>
import listActions from "@/components/mixins/list-actions"
import RecipientRow from "./RecipientRow"

export default {
  name: "RecipientList",
  components: {
    RecipientRow,
  },
  mixins: [listActions],
  data: function () {
    return {
      moduleName: 'messages',
      entitiesKey: 'recipients',
      formFields: {
        sort: {
          column: 'sSubscriberName',
          direction: 'desc',
        }
      },
    }
  },
  created(MessageService) {
    this.entityService = MessageService
    this.createdInit()
  },
  computed: {
    sortingTableTitles() {
      return [
        {key: 1, name: this.$gettext('Jméno a příjmení'), column: 'sSubscriberName'},
        {key: 2, name: this.$gettext('ID odběratele'), column: 'sIdSubscriber'},
        {key: 3, name: this.$gettext('Název operátora'), column: 'sIdOperator'},
        {key: 4, name: this.$gettext('Přečteno'), column: 'sRead'},
        {key: 5, name: this.$gettext('Smazáno'), column: 'sDeletedByDevice'},
        {key: 6, name: this.$gettext('Notifikace skryta'), column: 'sNotificationHidden'},
        {key: 7, name: this.$gettext('Datum přečtení'), column: 'sDateRecipientRead'},
        {key: 8, name: this.$gettext('Další informace'), skipInCsv: true},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles);
      headers.read.callback = entity => { return entity.read ? this.$gettext('Ano') : this.$gettext('Ne')};
      headers.id_operator.callback = entity => { return entity.operator_name}
      headers.deleted_by_device.callback = entity => { return entity.deleted ? this.$gettext('Ano') : this.$gettext('Ne')};
      headers.notification_hidden.callback = entity => { return entity.notification_hidden ? this.$gettext('Ano') : this.$gettext('Ne')};
      headers.date_recipient_read.callback = entity => {return this.$_datetime_format(entity.date_read)};


      return headers;
    },
  },
  methods: {
    getEntities() {
      this._processGetEntitiesResponse(this.entityService.getRecipients(this.$route.params.id, this._processFormFields(this.getFormFields())))
    },
    _exportCsv(){
      let formFields = this._processFormFields(this.getFormFields());
      delete formFields.limit;
      delete formFields.offset;
      this._processGetEntitiesCsvResponse(this.entityService.getRecipients(this.$route.params.id, formFields), this.csvHeaders);
    },
    saveFilterValues() {
      this.saveSearch(this.formFields.search)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/messages/recipients/RecipientList.vue